module.exports = __webpack_public_path__ + "img/romantik-guide1.85a38270.jpg";